module.exports = __webpack_public_path__ + "static/media/iconPaso2.903be937.svg";